import { PageFrame } from './Page/PageFrame'
import type { EditorMode } from '@/msgdeskRuntime/contracts/editorActions'
import { EnterPinForm, LoadingOverlay, QuickReply, ShellOverlays } from '@/deskUiSkeletons/Shared/Overlays'
import { PinDialog } from '@/deskUiSkeletons/Shared/PinDialog'
import { AuthEntry } from '@/deskUiSkeletons/Shared/AuthEntry'
import { StdMenu } from './StdMenu'

// Root of the parallel (v2) page template. Pure structural composition — it
// does NOT subscribe to the store, so legacy DOM visibility toggles on the
// chrome are never wiped by re-renders. Only caption leaves and the subs feed
// subscribe.
export function MsgPage({ isEditorOpen, editorMode }: { isEditorOpen?: boolean; editorMode?: EditorMode }) {
  return (
    <>
      <ShellOverlays />
      <StdMenu isEditorOpen={isEditorOpen} />
      {/* POSSESSION-MODEL: the logged identity lives at the page top-right
          (portal convention); the menu's right slot shows the desk state. */}
      <div className="md-topright-identity fixed right-2.5 top-2.5 z-[99999] flex h-[46px] items-center rounded-[14px] border border-[rgba(15,23,42,0.08)] bg-white/80 px-2 text-[#0f172a] shadow-[0_10px_30px_rgba(15,23,42,0.14),inset_0_1px_0_rgba(255,255,255,0.6)] backdrop-blur-[14px] font-[Arial,Tahoma,Verdana,sans-serif]">
        <AuthEntry skin={{
          root: 'flex items-center gap-1.5 text-[12px]',
          signInButton: 'h-[30px] rounded-[9px] px-2.5 text-[#147fcb] hover:bg-[#eceef5] whitespace-nowrap',
          identity: 'flex items-center gap-1 whitespace-nowrap',
          identityLink: 'text-[#147fcb] hover:underline max-w-[140px] overflow-hidden text-ellipsis',
          signOutButton: 'h-[30px] rounded-[9px] px-2 text-[#64748b] hover:bg-[#eceef5]',
        }} />
      </div>
      <PageFrame isEditorOpen={isEditorOpen} editorMode={editorMode} />
      <QuickReply />
      <EnterPinForm />
      <LoadingOverlay />
      <PinDialog />
    </>
  )
}
